/** IE CustomEvent Polyfill */
(function () {

  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();

/** Init Carousel */
window.initCarousel = function () {
  var carousel = document.querySelector('.carousel');

  if (carousel != null) {
    var images = carousel.querySelectorAll('img');

    for (var i = 0; i < images.length; i++) {
      if (images[i].complete) {
        imageLoaded(images[i]);
      } else {
        images[i].addEventListener('load', function (event) {
          imageLoaded(event.target);
        });
      }
    }

    function imageLoaded(image) {
      if (image.naturalWidth > image.naturalHeight) {
        image.parentElement.classList.add('landscape');
      } else if (image.naturalHeight > image.naturalWidth) {
        image.parentElement.classList.add('portrait');
      }
    }

    var items = document.querySelectorAll('.carousel__item'),
      indicator = document.querySelector('.carousel__indicator'),
      largeLink = document.querySelector('.carousel__large > .link'),
      close = document.querySelectorAll('.carousel__close'),
      closeChangeEvent = new CustomEvent('change'),
      itemCount = items.length,
      currentItem = 0;

    moveToSlide(0);

    function moveToSlide(n) { // set up our slide navigation functionality
      items[currentItem].className = 'carousel__item';
      currentItem = (n + itemCount) % itemCount;
      items[currentItem].className = 'carousel__item active';
      updateIndicator(n);
    }

    function nextSlide(e) {
      moveToSlide(currentItem + 1);
      var code = e.keyCode;
      if (code === 39) {
        moveToSlide(currentItem + 1);
      }
    };
    function prevSlide(e) {
      moveToSlide(currentItem + -1);
      var code = e.keyCode;
      if (code === 37) {
        moveToSlide(currentItem + -1);
      }
    };

    function updateLargeLink(n) {
      if (n === -1) {
        n = (itemCount - 1);
      }
      let image = items[n]?.querySelector('.carousel__image') ?? items[0]?.querySelector('.carousel__image');
      if (image?.src !== '' || image?.getAttribute('data-src') !== '') {
        largeLink.href = image?.src !== '' ? image?.src : image?.getAttribute('data-src');
      }
    }

    function updateIndicator(n) {
      indicator.innerHTML = currentItem + 1 + '/' + itemCount;
      updateLargeLink(n);
    }

    var slideHandlers = {
      nextSlide: function (element) {
        document.querySelector(element).addEventListener('click', nextSlide);
        document.body.addEventListener('keydown', nextSlide, false);
      },
      prevSlide: function (element) {
        document.querySelector(element).addEventListener('click', prevSlide);
        document.body.addEventListener('keydown', prevSlide, false);
      }
    }

    slideHandlers.nextSlide('.carousel__next');
    slideHandlers.prevSlide('.carousel__prev');

    if (close.length > 0) {
      close.forEach(function(item, index) {
        item.addEventListener('click', closeCarousel);
      });
    }

    function closeCarousel(event) {
      var revealPanel = closestByClass(event.target, 'reveal__panel');

      // if iframe, reset src to stop the interaction on close
      if ( document.querySelector('.iframed') ) {
        var iframed = document.querySelector('.iframed');
        var iframeSrc = iframed.getAttribute('src');
        iframed.setAttribute('src', iframeSrc);
      }

      if (revealPanel) {
        var revealController = revealPanel.parentElement.querySelector('.reveal__controller');
        revealController.checked = false;
        revealController.dispatchEvent(closeChangeEvent);
      } else {
        carousel.style.display = 'none';
      }
    }

    function closestByClass(element, className) {
      while (element.className != className) {
        element = element.parentNode;
        if (!element) {
          return null;
        }
      }

      return element;
    }

    // Detect swipe events for touch devices, credit to Kirupa @ https://www.kirupa.com/html5/detecting_touch_swipe_gestures.htm
    var initialX = null;
    var initialY = null;

    function startTouch(e) {
      initialX = e.touches[0].clientX;
      initialY = e.touches[0].clientY;
    };

    function moveTouch(e) {
      if (initialX === null) {
        return;
      }
      if (initialY === null) {
        return;
      }
      var currentX = e.touches[0].clientX;
      var currentY = e.touches[0].clientY;
      var diffX = initialX - currentX;
      var diffY = initialY - currentY;
      if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) {
          // swiped left
          moveToSlide(currentItem + 1);
        } else {
          // swiped right
          moveToSlide(currentItem + -1);
        }
      }
      initialX = null;
      initialY = null;
      e.preventDefault();
    };

    carousel.addEventListener("touchstart", startTouch, {passive: true});
    carousel.addEventListener("touchmove", moveTouch, {passive: true});
  }
};

/** get in call stack **/
setTimeout(function() {
  initCarousel();
}, 100 );
